import { render, staticRenderFns } from "./删除组件.vue?vue&type=template&id=357e56a8&scoped=true&"
import script from "./删除组件.vue?vue&type=script&lang=js&"
export * from "./删除组件.vue?vue&type=script&lang=js&"
import style0 from "./删除组件.vue?vue&type=style&index=0&id=357e56a8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357e56a8",
  null
  
)

export default component.exports